module.exports = __webpack_public_path__ + "img/software-sub-bg.0a046231.png";